import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/alejandro/bg_alejandro.png';
import Photo1 from '../../../../../Images/modals/photographers/alejandro/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/alejandro/photo-2.png';
import Photo3 from '../../../../../Images/modals/photographers/alejandro/photo-3.png';
import Photo4 from '../../../../../Images/modals/photographers/alejandro/photo-4.png';

import {
  Photo_Alejandro,
  Text_Alejandro,
  TextPhoto1_Alejandro,
  TextPhoto2_Alejandro,
  TextPhoto3_Alejandro,
  TextPhoto4_Alejandro,
} from '../../../../../utils/EN/Modals/photographers';

const ModalPhotoAlejandro = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-alejandro"
        mainBg={PhotoBg}
        directorName={Photo_Alejandro}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Alejandro}
        directorText={Text_Alejandro}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Alejandro}
        rowImage2={Photo3}
        videoText3={TextPhoto3_Alejandro}
        rowImage3={Photo4}
        videoText4={TextPhoto4_Alejandro}
        mainGallery={'alejandro-gallery-1'}
        gallery2={'alejandro-gallery-2'}
        gallery3={'alejandro-gallery-3'}
        gallery4={'alejandro-gallery-4'}
      />
    </>
  );
};

export default ModalPhotoAlejandro;
